// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"83":"46b17ca9","492":"dffdd8a9","628":"fb93b1ba","974":"2855de6c"}[chunkId] + ".chunk.css";
};